import { createContext, use } from 'react';
import invariant from 'tiny-invariant';

export const ForumContext = createContext<{
  headerPortal: HTMLDivElement | null;
} | null>(null);

export const useForumContext = () => {
  const context = use(ForumContext);

  invariant(context, 'Forum components must be a child of <ForumLayout />');

  return context;
};
